import React from 'react';
import PropTypes from 'prop-types';
import ComeetApply from './ComeetApply';

import './style.scss';

function Apply({ positionUid }) {
    return (
        <div className="apply-section">
            <h1>Apply for this Position</h1>
            <ComeetApply positionUid={positionUid} />
        </div>
    );
}

Apply.propTypes = {
    positionUid: PropTypes.string.isRequired,
};

export default Apply;
